/**
 * Saved Message Service - Servicio de mensajes guardados
 */

import { ApiServiceBase } from '../core/ApiService';
import type { SavedMessage } from '../types/common';

export class SavedMessageService extends ApiServiceBase {
  /**
   * Obtiene todos los mensajes guardados del usuario
   */
  async getSavedMessages(): Promise<SavedMessage[]> {
    return this.request(`/saved-messages`, {
      method: 'GET',
    }).then((data: any) => data.messages || []);
  }

  /**
   * Guarda un mensaje en la colección de mensajes guardados
   */
  async saveChatMessage(data: {
    message_id: string;
    title?: string;
    notes?: string;
    tags?: string[];
    content?: string;
  }): Promise<SavedMessage> {
    return this.request('/saved-messages', {
      method: 'POST',
      body: JSON.stringify(data),
    }).then((result: any) => result.saved_message);
  }

  /**
   * Actualiza un mensaje guardado
   */
  async updateSavedMessage(savedMessageId: string, data: {
    title?: string;
    notes?: string;
    tags?: string[];
    order_index?: number;
    content?: string;
  }): Promise<SavedMessage> {
    return this.request(`/saved-messages/${savedMessageId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }).then((result: any) => result.saved_message);
  }

  /**
   * Elimina un mensaje guardado
   */
  async deleteSavedMessage(savedMessageId: string): Promise<void> {
    await this.request(`/saved-messages/${savedMessageId}`, {
      method: 'DELETE',
    });
  }

  /**
   * Reordena mensajes guardados
   */
  async reorderSavedMessages(order: Array<{ id: string; order_index: number }>): Promise<void> {
    await this.request('/saved-messages/reorder', {
      method: 'POST',
      body: JSON.stringify({ order }),
    });
  }
}
